import { connect } from "react-redux";

import { block_ssn, unblock_ssn } from "./actions/commands";
import { fetch_ssn_block_info } from "./actions/queries";
//import { mergeProps } from '../../mergeProps';

function mapStateToProps(state) {
  return {
    ssnBlock: state.ssnBlock,
    fetched: state.ssnBlock.fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    blockSsn: (ssn, reason) => {
      dispatch(block_ssn(ssn, reason));
    },
    unblockSsn: (ssn) => {
      dispatch(unblock_ssn(ssn));
    },
    getBlockInfo: (ssn) => {
      dispatch(fetch_ssn_block_info(ssn));
    },
  };
}

const ssnBlockingService = connect(mapStateToProps, mapDispatchToProps);
export default ssnBlockingService;
